var _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPriceTag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 3352,
    height: 3352,
    viewBox: "0 0 3352 3352",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M779.939 832.398C779.939 804.784 802.325 782.398 829.939 782.398L1780.29 782.398C1793.56 782.398 1806.27 787.666 1815.65 797.043L3042.31 2023.7C3061.83 2043.22 3061.83 2074.88 3042.31 2094.41L2091.95 3044.76C2072.43 3064.29 2040.77 3064.29 2021.24 3044.76L794.583 1818.1C785.207 1808.72 779.939 1796.01 779.939 1782.74L779.939 832.398ZM2125.63 3282.59C2125.16 3283.08 2124.68 3283.57 2124.19 3284.06C2086.87 3321.39 2026.34 3321.39 1989.01 3284.06L615.555 1910.6C600.245 1895.29 592.625 1875.2 592.696 1855.13C592.716 1849.25 592.462 1843.33 591.357 1837.55C589.113 1825.81 587.939 1813.69 587.939 1801.29L587.939 786.636C587.939 732.46 610.377 683.524 646.467 648.616C681.356 612.708 730.166 590.398 784.186 590.398L1805.91 590.398C1870.4 590.398 1927.46 622.186 1962.27 670.946C1964.12 673.525 1966.12 675.987 1968.36 678.228L3281.02 1990.88C3318.67 2028.54 3318.67 2089.58 3281.02 2127.23C3277.09 2131.17 3272.89 2134.69 3268.5 2137.79C3257.98 2145.22 3248.67 2154.53 3241.24 2165.05C3238.14 2169.44 3234.62 2173.63 3230.69 2177.56L2126.83 3281.41C2126.44 3281.81 2126.04 3282.2 2125.63 3282.59Z",
    fill: "#98A6AD"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 1074.43,
    cy: 1074.05,
    r: 153,
    transform: "rotate(-45 1074.43 1074.05)",
    fill: "#98A6AD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPriceTag);
export default __webpack_public_path__ + "static/media/priceTag.2e427d1f77a2690313b79e2d27e71628.svg";
export { ForwardRef as ReactComponent };